import { JsonSerializable } from '../shared/jsonSerializable';
import { User } from '../entity/user';
import { Contact } from '../entity/contact';
import { Sample } from '../entity/sample';
import { Job } from '../entity/job';
import { Package } from '../entity/package';
import { ProductClass } from '../entity/product-class';
import { RequestStatus } from '../entity/request-status';
import { RequestIncident } from '../entity/request-incident';
import { RequestThirdParty } from '../entity/request-third-party';
import * as moment from 'moment/moment';

export class Request extends JsonSerializable {

  billingMode: string;
  clientRequestIncident: any;
  clientRequestStatus: RequestStatus;
  job: Job;
  limsRequestIncident: any;
  limsRequestStatus: RequestStatus;
  number: string;
  orderNumber: string;
  samples: Sample[];
  takingDate: string;
  analysisDate: string;
  receptionDate: string;
  validationDate: string;
  reasonCode: string;
  reasonLabel: string;
  reasonClass: string;
  externalReference: string;
  repriseIp: boolean;
  packages: Package[];
  productClass: ProductClass;
  thirdParties: RequestThirdParty[];

  constructor() {
    super();
    this.billingMode = null;
    this.clientRequestIncident = null;
    this.clientRequestStatus = null;
    this.job = null;
    this.limsRequestIncident = null;
    this.limsRequestStatus = null;
    this.number = null;
    this.orderNumber = null;
    this.samples = new Array<Sample>();
    this.takingDate = null;
    this.analysisDate = null;
    this.receptionDate = null;
    this.validationDate = null;
    this.reasonCode = null;
    this.reasonLabel = null;
    this.reasonClass = null;
    this.packages = new Array<Package>();
    this.productClass = null;
    this.externalReference = "";
    this.repriseIp = null;
    this.thirdParties = new Array<RequestThirdParty>();
  }

  fromJSON(jsonObj: Object) {
    for (var propName in jsonObj) {
      if (this.hasOwnProperty(propName)) {
        if(Array.isArray(jsonObj[propName])){
          for (let i in jsonObj[propName]) {
            if(jsonObj[propName] instanceof Object){
              if (propName == "samples") {
                this[propName][i] = new Sample();
                let item_data = jsonObj[propName][i]['sample'];
                if(item_data==null){
                  item_data = jsonObj[propName][i];
                }
                this[propName][i].fromJSON(item_data);
              } else if (propName == "packages") {
                this[propName][i] = new Package();
                let item_data = jsonObj[propName][i]['package'];
                if(item_data==null){
                  item_data = jsonObj[propName][i];
                }
                this[propName][i].fromJSON(item_data);
              } else if (propName === 'thirdParties') {
                this[propName][i] = new RequestThirdParty();
                this[propName][i].fromJSON(jsonObj[propName][i]);
              }
            } else {
              this[propName][i] = jsonObj[propName][i];
            }
          }
        } else {
          if(jsonObj[propName] instanceof Object){
            if (propName == "job") {
              this[propName] = new Job();
            } else if (propName == "productClass") {
              this[propName] = new ProductClass();
            } else if (propName == "clientRequestStatus" || propName == "limsRequestStatus") {
              this[propName] = new RequestStatus();
            } else if (propName == "clientRequestIncident" || propName == "limsRequestIncident") {
              this[propName] = new RequestIncident();
            }
            this[propName].fromJSON(jsonObj[propName]);
          }  else {
            this[propName] = jsonObj[propName];
          }
        }
      }
    }
  }
}







// WEBPACK FOOTER //
// ./src/app/entity/request.ts